// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: var(--background);
	gap: 160px;
	width: 100%;
}

.home-content-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	gap: 180px;
}

.home-section-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	padding: 0 20px;
}

.home-introduction-block {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 120px;
	padding-top: 100px;
	position: relative;
	max-width: 1340px;
	margin-bottom: -40px;
}

.home-introduction__title-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.home-introduction__title-block {
	display: flex;
	flex-direction: column;
	width: fit-content;
	align-items: end;
	width: 100%;
}

.home-introduction__title {
	font-size: 128px;
	text-transform: uppercase;
	line-height: 129px;
	font-family: "Pridi", serif !important;
	font-weight: 500;
	animation: title 2.5s;
	text-align: center;
	letter-spacing: 0.11em;
}

.home-introduction__title-wrapper {
	overflow: hidden;
}

.home-introduction__subtitle {
	font-size: 64px;
	font-family: "Poppins", sans-serif;
	line-height: 77px;
	letter-spacing: 0.26em;
	font-weight: 300;
	text-align: end;
	animation: subtitle 2.5s;
}

@keyframes title {
	0% {
		transform: rotate(9deg) translateY(170px);
	}

	100% {
		transform: rotate(0deg) translateY(0px);
	}
}

@keyframes subtitle {
	0% {
		transform: rotate(12deg) translateY(90px);
	}

	100% {
		transform: rotate(0deg) translateY(0px);
	}
}

.home-introduction__join-us-block {
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
}

.home-introduction__join-us-button {
	text-transform: uppercase;
	font-size: 32px;
	font-family: "Poppins", sans-serif;
	line-height: 38px;
	color: var(--dark);
	width: fit-content;
	padding: 0 24px;
	background-color: var(--button);
	color: var(--background);
	height: 60px;
	border-radius: 12px;
	transition: 0.3s;
}

.home-introduction__join-us-button:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.home-introduction__directions-block {
	display: flex;
	flex-direction: row;
	gap: 24px;
	justify-content: center;
	position: absolute;
	bottom: 24px;
	right: 20px;
}

.home-introduction__direction-item {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 39px;
	border-radius: 40px;
	border: 1px solid var(--dark);
	padding: 0 20px;
	text-transform: uppercase;
}

.home-about-block {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 12px;
	position: relative;
	max-width: 1340px;
}

.home__animation-wrapper {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	-webkit-user-select: none;
	        user-select: none;
	pointer-events: none;
}

.home-about__main-intro {
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: end;
}

.home-about__what-we-do {
	font-family: "Poppins", sans-serif;
	font-weight: 500;
	font-size: 48px;
	text-transform: uppercase;
	color: var(--dark);
}

.home-about__what-we-do-description {
	font-family: "Poppins", sans-serif;
	max-width: 550px;
	text-align: end;
	font-size: 20px;
	line-height: 24px;
	color: var(--dark);
}

.home-about__offers-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding-bottom: 40px;
}

.home-about__offer-block {
	display: flex;
	flex-direction: column;
	gap: 16px;
	max-width: 440px;
	width: 100%;
	align-items: center;
	min-height: 230px;
}

.home-about__offer-block.center {
	margin: 0 auto;
}

.home-about__offer-block.end {
	margin-left: auto;
}

.home-about__offer-text-block {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
}

.home-about__offer-block-title {
	font-family: "Poppins", sans-serif;
	font-size: 32px;
	line-height: 32px;
	font-weight: 400;
	color: var(--dark);
	max-width: 374px;
	text-align: center;
}

.home-about__offer-block-description {
	font-family: "Poppins", sans-serif;
	font-size: 20px;
	line-height: 24px;
	color: var(--dark);
	text-align: center;
	font-weight: 300;
}

.home-usage-block {
	display: grid;
	gap: 40px;
	width: 100%;
	grid-template-columns: 520px 1fr;
	max-width: 1340px;
}

.home-usage__information-block {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 80px;
	width: 100%;
}

.home-usage__description-block {
	display: flex;
	flex-direction: column;
	gap: 12px;
	font-family: "Poppins", sans-serif;
}

.home-usage__title {
	font-size: 48px;
	font-weight: 400;
	line-height: 48px;
	color: var(--dark);
	text-transform: uppercase;
	font-family: "Poppins", sans-serif;
}

.home-usage__subtitle {
	font-size: 32px;
	line-height: 32px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
}

.home-usage__description {
	font-size: 20px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 300;
}

.home-usage__join-button {
	height: 60px;
	padding: 0 20px;
	width: fit-content;
	border-radius: 12px;
	background-color: var(--button);
	color: var(--background);
	margin-top: 40px;
	font-size: 20px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 500;
	text-transform: uppercase;
	transition: 0.3s;
}

.home-usage__join-button:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.home-usage__videos-block {
	width: 100%;
	height: 100%;
	display: flex;
}

.home-usage__video-wrapper {
	width: 150px;
	height: 100%;
	position: relative;
	transition: 0.5s;
	border-radius: 30px;
	border: 2px solid var(--background);
	z-index: 1;
}

.home-usage__video-wrapper.current {
	width: calc(100% - 120px);
	transition: 0.5s;
	z-index: 2;
}

.home-usage__video-wrapper.current.first {
	margin-right: -30px;
}

.home-usage__video-wrapper.current.second {
	margin-left: -30px;
}

.home-usage__video {
	width: 100%;
	height: 100%;
	border-radius: 30px;
	transition: 0.5s;
}

.home-usage__video-dark-block {
	width: 100%;
	height: 100%;
	position: absolute;
	background-color: rgba(0, 0, 0, 0.6);
	border-radius: 30px;
	left: 0;
	top: 0;
	cursor: pointer;
	transition: 0.5s;
}

.home-story-block {
	display: grid;
	grid-template-columns: 1fr 530px;
	gap: 40px;
	width: 100%;
	max-width: 1340px;
	padding-bottom: 80px;
}

.home-story__image-block {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding-right: 100px;
	position: relative;
}

.home-story__image-block img {
	width: 100%;
}

.home-story__text-block {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 40px;
	align-items: end;
}

.home-story__points {
	position: absolute;
	bottom: 20px;
	right: 0;
	max-width: 280px;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.home-story__point {
	background-color: var(--button);
	height: 65px;
	padding: 0 20px;
	border-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--background);
	font-size: 24px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	text-align: center;
	text-transform: uppercase;
}

.home-story__title {
	font-size: 48px;
	line-height: 48px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	text-transform: uppercase;
	color: var(--dark);
	text-align: end;
}

.home-story__text {
	font-size: 20px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 300;
	text-align: end;
	color: var(--dark);
}

.home-story__conclusion {
	font-size: 24px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	text-align: end;
	color: var(--dark);
	text-transform: uppercase;
}

.home-usage__description-block-mobile {
	display: none;
}

.home-story__title-mobile {
	display: none;
}

.home-usage__mobile-video-dots {
	display: none;
}

@media (max-width: 1150px) {
	.home-usage-block {
		display: grid;
		gap: 40px;
		width: 100%;
		grid-template-columns: 420px 1fr;
		max-width: 1340px;
		margin-top: -40px;
	}

	.home-about__offer-block {
		display: flex;
		flex-direction: column;
		gap: 16px;
		max-width: 440px;
		width: 100%;
		align-items: center;
		min-height: fit-content;
	}

	.home-usage__information-block {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 60px;
		width: 100%;
	}

	.home-usage__title {
		font-size: 42px;
		font-weight: 400;
		line-height: 42px;
		color: var(--dark);
		text-transform: uppercase;
		font-family: "Poppins", sans-serif;
	}

	.home-usage__subtitle {
		font-size: 26px;
		line-height: 26px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
	}

	.home-usage__description {
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 300;
	}

	.home-usage__join-button {
		height: 50px;
		padding: 0 20px;
		width: fit-content;
		border-radius: 12px;
		background-color: var(--button);
		color: var(--background);
		margin-top: 30px;
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 500;
		text-transform: uppercase;
	}

	.home-story__text-block {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 32px;
		align-items: end;
	}

	.home-story__points {
		position: absolute;
		bottom: 20px;
		right: 0;
		max-width: 250px;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.home-story__point {
		background-color: var(--button);
		height: 50px;
		padding: 0 20px;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--background);
		font-size: 18px;
		line-height: 22px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-align: center;
		text-transform: uppercase;
	}

	.home-story__title {
		font-size: 42px;
		line-height: 42px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-transform: uppercase;
		color: var(--dark);
		text-align: end;
	}

	.home-story__text {
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 300;
		text-align: end;
		color: var(--dark);
	}

	.home-story__conclusion {
		font-size: 20px;
		line-height: 24px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-align: end;
		color: var(--dark);
		text-transform: uppercase;
	}

	.home-story-block {
		display: grid;
		grid-template-columns: 1fr 500px;
		gap: 40px;
		width: 100%;
		max-width: 1340px;
		padding-bottom: 80px;
	}

	.home-introduction__title {
		font-size: 80px;
		text-transform: uppercase;
		line-height: 96px;
		font-family: "Pridi", serif !important;
		font-weight: 500;
		animation: title 2.5s;
	}

	.home-introduction__subtitle {
		font-size: 52px;
		font-family: "Poppins", sans-serif;
		line-height: 60px;
		letter-spacing: 0.18em;
		font-weight: 300;
		text-align: end;
		animation: subtitle 2.5s;
	}

	.home-introduction-block {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 80px;
		padding-top: 100px;
		padding-bottom: 0px;
		position: relative;
		max-width: 1340px;
	}

	.home-about__what-we-do {
		font-family: "Poppins", sans-serif;
		font-weight: 500;
		font-size: 42px;
		line-height: 42px;
		text-transform: uppercase;
		color: var(--dark);
	}

	.home-about__what-we-do-description {
		font-family: "Poppins", sans-serif;
		max-width: 450px;
		text-align: end;
		font-size: 16px;
		line-height: 20px;
		color: var(--dark);
	}

	.home-about-block {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 12px;
		position: relative;
		max-width: 1340px;
		padding-bottom: 40px;
	}

	.home-about__offer-block-title {
		font-family: "Poppins", sans-serif;
		font-size: 30px;
		line-height: 30px;
		font-weight: 400;
		color: var(--dark);
		max-width: 374px;
		text-align: center;
	}

	.home-about__offer-block-description {
		font-family: "Poppins", sans-serif;
		font-size: 19px;
		line-height: 20px;
		color: var(--dark);
		text-align: center;
		font-weight: 300;
	}

	.home-about__offer-text-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
	}
}

@media (max-width: 950px) {
	.home-introduction-block {
		min-height: calc(100vh - 70px);
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 60px;
		padding-top: 80px;
		padding-bottom: 60px;
		position: relative;
		max-width: 1340px;
	}

	.home-introduction__title {
		font-size: 36px;
		text-transform: uppercase;
		line-height: 42px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		animation: title 2.5s;
	}

	.home-introduction__subtitle {
		font-size: 24px;
		font-family: "Poppins", sans-serif;
		line-height: 64px;
		letter-spacing: 0.1em;
		font-weight: 300;
		text-align: end;
		animation: subtitle 2.5s;
	}

	.home-introduction__join-us-button {
		text-transform: uppercase;
		font-size: 22px;
		font-family: "Poppins", sans-serif;
		line-height: 26px;
		color: var(--dark);
		width: fit-content;
		padding: 0 16px;
		background-color: var(--button);
		color: var(--background);
		height: 44px;
		border-radius: 12px;
	}

	.home-introduction__directions-block {
		display: flex;
		flex-direction: row;
		gap: 16px;
		justify-content: center;
		position: absolute;
		bottom: 20px;
		right: 50%;
		transform: translateX(50%);
	}

	.home-introduction__direction-item {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 32px;
		border-radius: 20px;
		border: 1px solid var(--dark);
		padding: 0 8px;
		text-transform: uppercase;
		font-size: 14px;
		white-space: nowrap;
	}

	.home-content-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		align-items: center;
		gap: 80px;
	}

	.home-introduction__join-us-block img {
		max-height: 26px;
	}

	.home-about__main-intro {
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: start;
	}

	.home-about__what-we-do {
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		font-size: 32px;
		line-height: 32px;
		text-transform: uppercase;
		color: var(--dark);
	}

	.home-about__what-we-do-description {
		font-family: "Poppins", sans-serif;
		max-width: 550px;
		text-align: start;
		font-size: 14px;
		line-height: 18px;
		color: var(--dark);
	}

	.home-about-block {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 30px;
		position: relative;
		max-width: 1340px;
		padding-bottom: 0;
	}

	.home-about__offers-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding-bottom: 40px;
		gap: 16px;
	}

	.home-about__offer-text-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	}

	.home-about__offer-block-title {
		font-family: "Poppins", sans-serif;
		font-size: 20px;
		line-height: 22px;
		font-weight: 400;
		color: var(--dark);
		max-width: 374px;
		text-align: center;
	}

	.home-about__offer-block-description {
		font-family: "Poppins", sans-serif;
		font-size: 14px;
		line-height: 18px;
		color: var(--dark);
		text-align: center;
		font-weight: 300;
	}

	.home-usage-block {
		display: grid;
		gap: 24px;
		width: 100%;
		grid-template-columns: 1fr;
		max-width: 1340px;
	}

	.home-usage__description-block {
		display: none;
		flex-direction: column;
		gap: 12px;
		font-family: "Poppins", sans-serif;
	}

	.home-usage__title {
		font-size: 32px;
		font-weight: 400;
		line-height: 32px;
		color: var(--dark);
		text-transform: uppercase;
		font-family: "Poppins", sans-serif;
	}

	.home-usage__description-block-mobile {
		display: flex;
		flex-direction: column;
		gap: 12px;
		font-family: "Poppins", sans-serif;
	}

	.home-usage__video-wrapper {
		width: 150px;
		height: 100%;
		position: relative;
		transition: 0.5s;
		border-radius: 16px;
		border: 2px solid var(--background);
		z-index: 1;
		display: none;
	}

	.home-usage__video-wrapper.current {
		display: block;
		width: 100%;
		min-height: 240px;
		transition: 0.5s;
		z-index: 2;
	}

	.home-usage__video-wrapper.current.first {
		margin-right: 0px;
	}

	.home-usage__video-wrapper.current.second {
		margin-left: 0px;
	}

	.home-usage__video {
		width: 100%;
		height: 100%;
		border-radius: 16px;
		transition: 0.5s;
	}

	.home-usage__subtitle {
		font-size: 20px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
	}

	.home-usage__description {
		font-size: 14px;
		line-height: 18px;
		font-family: "Poppins", sans-serif;
		font-weight: 300;
	}

	.home-usage__join-button {
		height: 44px;
		padding: 0 16px;
		width: fit-content;
		border-radius: 12px;
		background-color: var(--button);
		color: var(--background);
		margin-top: 10px;
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-transform: uppercase;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.home-story-block {
		display: grid;
		grid-template-columns: 1fr;
		gap: 30px;
		width: 100%;
		max-width: 1340px;
		padding-bottom: 80px;
	}

	.home-story__image-block {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		padding-right: 0;
		position: relative;
	}

	.home-story__points {
		position: absolute;
		bottom: 20px;
		right: 0;
		max-width: 280px;
		width: 100%;
		display: none;
		flex-direction: column;
		gap: 16px;
	}

	.home-story__title {
		font-size: 48px;
		line-height: 48px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-transform: uppercase;
		color: var(--dark);
		text-align: end;
		display: none;
	}

	.home-story__title-mobile {
		font-size: 32px;
		line-height: 32px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-transform: uppercase;
		color: var(--dark);
		text-align: start;
		display: block;
	}

	.home-story__text-block {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: start;
	}

	.home-story__text {
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 300;
		text-align: start;
		color: var(--dark);
	}

	.home-story__conclusion {
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		font-weight: 400;
		text-align: start;
		color: var(--dark);
		text-transform: uppercase;
	}

	.home-usage__videos-block {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: center;
	}

	.home-usage__mobile-video-dots {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.home-usage__mobile-video-dot {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: var(--gray);
	}

	.home-usage__mobile-video-dot.current {
		background-color: var(--button);
	}
}

.banner {
	min-height: 500px;
	background: linear-gradient(360deg, #e9eff2 0%, #f6fbff 100%);
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

.section-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
}

.banner-headline {
	font-style: normal;
	font-weight: 900;
	font-size: 64px;
	line-height: 120%;
	text-align: center;
	text-transform: uppercase;
	color: #203f70;
}

.banner-title {
	font-style: normal;
	font-weight: 300;
	font-size: 64px;
	line-height: 100%;
	color: #203f70;
}

.about-us {
	position: relative;
	z-index: 1;
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
}

.about-headline {
	font-style: normal;
	font-weight: 300;
	font-size: 52px;
	line-height: 100%;
	color: #203f70;
}

.about-title {
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 36px;
	text-align: center;
	color: #000000;
}

.max-width-785 {
	max-width: 785px;
}

.about-description {
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #707070;
}

.about-row {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.about-block {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	max-width: 380px;
}

.about-wrapper {
	max-width: 360px;
}

.about-wrapper img {
	width: 42px;
	height: 42px;
}

.about-bllock-title {
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 36px;
	color: #000000;
	margin-top: 10px !important;
}

.about-bllock-desc {
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #707070;
}

.about-img-block img {
	max-width: 340px;
	margin-right: 15px;
}

@media (max-width: 1400px) {
	.about-block {
		max-width: 100%;
		flex-basis: 100%;
		margin: 0 !important;
		align-items: center;
	}

	.about-img-block {
		margin-top: 20px;
		margin-bottom: 20px;
	}
}

.product-promotion {
	padding: 100px 0;
	padding-top: 0px;
	background: #cbdefd;
	display: flex;
	align-items: center;
	justify-content: center;
}

.promotion-wrapper {
	width: 50%;
	flex-basis: 50%;
	max-width: 540px;
}

.promotion-headline {
	padding-bottom: 100px;
	font-style: normal;
	font-weight: 300;
	font-size: 52px;
	line-height: 100%;
	color: #203f70;
}

.promotion-block {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
}

.promotion-block img {
	width: 100%;
	max-width: 580px;
}

.promotion-block-title {
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 36px;
	color: #000000;
}

.promotion-block-subtitle {
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #000000;
}

.promotion-bllock-desc {
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #000000;
}

@media (max-width: 992px) {
	.product-promotion-grid {
		flex-direction: column !important;
		align-items: center !important;
	}

	.promotion-block {
		margin: 15px 0px !important;
	}

	.product-promotion {
		padding: 50px 0;
	}

	.about-row {
		flex-wrap: wrap;
	}

	.about-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.about-bllock-title {
		text-align: center;
	}

	.about-bllock-desc {
		text-align: center;
	}

	.promotion-wrapper {
		width: 70%;
	}

	.promotion-btn {
		margin-top: 10px !important;
		align-items: center;
	}

	.about-wrapper {
		max-width: 450px;
	}
}

.quote-area {
	padding: 70px 0;
	background: linear-gradient(
		360deg,
		#e9eff2 7.29%,
		#e9eff2 19.79%,
		#f6fbff 100%
	);
}

.quote-area-title {
	font-style: normal;
	font-weight: 300;
	font-size: 52px;
	line-height: 100%;
	color: #203f70;
}

@media (max-width: 500px) {
	.banner-headline {
		font-size: 48px;
	}

	.banner-title {
		font-size: 48px;
	}

	.about-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.about-bllock-title {
		text-align: center;
	}

	.about-bllock-desc {
		text-align: center;
	}

	.about-img-block img {
		margin-right: 0px;
	}

	.promotion-wrapper {
		width: 80%;
	}

	.promotion-btn {
		margin-top: 10px !important;
	}

	.about-headline {
		text-align: center;
	}
}

.our-story {
	position: relative;
	z-index: 1;
	background-color: #203f70;
	display: flex;
	align-items: center;
	justify-content: center;
}

.story-block {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	max-width: 600px;
}

.story-row {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.story-image-block img {
	max-width: 160px;
	margin-right: 60px;
}

.story-headline {
	font-style: normal;
	font-weight: 300;
	font-size: 52px;
	line-height: 100%;
	color: #ffffff;
}

.story-description {
	font-style: normal;
	font-weight: 300;
	font-size: 20px;
	line-height: 24px;
	text-align: left;
	color: #ffffff;
}

.story-description-emph {
	font-style: normal;
	font-weight: 300;
	font-size: 28px;
	line-height: 28px;
	text-align: center;
	color: #ffffff;
}

.story-title {
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 36px;
	text-align: left;
	color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/Home/Home.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,mCAAmC;CACnC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,sCAAsC;CACtC,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,sBAAsB;CACtB,gBAAgB;CAChB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC;EACC,yCAAyC;CAC1C;;CAEA;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC;EACC,yCAAyC;CAC1C;;CAEA;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,+BAA+B;CAC/B,wBAAwB;CACxB,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,mBAAmB;CACnB,6BAA6B;CAC7B,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,YAAY;CACZ,yBAAiB;SAAjB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,+BAA+B;CAC/B,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,mCAAmC;CACnC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,oCAAoC;CACpC,mBAAmB;CACnB,OAAO;CACP,MAAM;CACN,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,SAAS;CACT,WAAW;CACX,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,+BAA+B;CAC/B,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,wBAAwB;CACxB,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,aAAa;EACb,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;CACnC;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;CAC1B;;CAEA;EACC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;CACrB;;CAEA;EACC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;CACtB;;CAEA;EACC,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;CACzB;;CAEA;EACC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;CACrB;;CAEA;EACC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;CACV;AACD;;AAEA;CACC;EACC,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;CACtB;;CAEA;EACC,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;CACzB;;CAEA;EACC,yBAAyB;EACzB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,0BAA0B;CAC3B;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,SAAS;CACV;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,SAAS;CACV;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;CACV;;CAEA;EACC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;CACnC;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;CACnC;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;CACnC;;CAEA;EACC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,UAAU;EACV,aAAa;CACd;;CAEA;EACC,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;CACX;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;CACT;;CAEA;EACC,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;CACrB;;CAEA;EACC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;CACd;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;CACf;;CAEA;EACC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,QAAQ;CACT;;CAEA;EACC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;CAC9B;;CAEA;EACC,+BAA+B;CAChC;AACD;;AAEA;CACC,iBAAiB;CACjB,6DAA6D;CAC7D,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;CACpB;AACD;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC;EACC,iCAAiC;EACjC,8BAA8B;CAC/B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,2BAA2B;EAC3B,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,eAAe;CACf;;;;;EAKC;AACF;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf","sourcesContent":[".home-page-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tbackground-color: var(--background);\n\tgap: 160px;\n\twidth: 100%;\n}\n\n.home-content-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\talign-items: center;\n\tgap: 180px;\n}\n\n.home-section-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\talign-items: center;\n\tpadding: 0 20px;\n}\n\n.home-introduction-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 120px;\n\tpadding-top: 100px;\n\tposition: relative;\n\tmax-width: 1340px;\n\tmargin-bottom: -40px;\n}\n\n.home-introduction__title-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.home-introduction__title-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: fit-content;\n\talign-items: end;\n\twidth: 100%;\n}\n\n.home-introduction__title {\n\tfont-size: 128px;\n\ttext-transform: uppercase;\n\tline-height: 129px;\n\tfont-family: \"Pridi\", serif !important;\n\tfont-weight: 500;\n\tanimation: title 2.5s;\n\ttext-align: center;\n\tletter-spacing: 0.11em;\n}\n\n.home-introduction__title-wrapper {\n\toverflow: hidden;\n}\n\n.home-introduction__subtitle {\n\tfont-size: 64px;\n\tfont-family: \"Poppins\", sans-serif;\n\tline-height: 77px;\n\tletter-spacing: 0.26em;\n\tfont-weight: 300;\n\ttext-align: end;\n\tanimation: subtitle 2.5s;\n}\n\n@keyframes title {\n\t0% {\n\t\ttransform: rotate(9deg) translateY(170px);\n\t}\n\n\t100% {\n\t\ttransform: rotate(0deg) translateY(0px);\n\t}\n}\n\n@keyframes subtitle {\n\t0% {\n\t\ttransform: rotate(12deg) translateY(90px);\n\t}\n\n\t100% {\n\t\ttransform: rotate(0deg) translateY(0px);\n\t}\n}\n\n.home-introduction__join-us-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\talign-items: center;\n}\n\n.home-introduction__join-us-button {\n\ttext-transform: uppercase;\n\tfont-size: 32px;\n\tfont-family: \"Poppins\", sans-serif;\n\tline-height: 38px;\n\tcolor: var(--dark);\n\twidth: fit-content;\n\tpadding: 0 24px;\n\tbackground-color: var(--button);\n\tcolor: var(--background);\n\theight: 60px;\n\tborder-radius: 12px;\n\ttransition: 0.3s;\n}\n\n.home-introduction__join-us-button:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.home-introduction__directions-block {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 24px;\n\tjustify-content: center;\n\tposition: absolute;\n\tbottom: 24px;\n\tright: 20px;\n}\n\n.home-introduction__direction-item {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 39px;\n\tborder-radius: 40px;\n\tborder: 1px solid var(--dark);\n\tpadding: 0 20px;\n\ttext-transform: uppercase;\n}\n\n.home-about-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 12px;\n\tposition: relative;\n\tmax-width: 1340px;\n}\n\n.home__animation-wrapper {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tuser-select: none;\n\tpointer-events: none;\n}\n\n.home-about__main-intro {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\talign-items: end;\n}\n\n.home-about__what-we-do {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 500;\n\tfont-size: 48px;\n\ttext-transform: uppercase;\n\tcolor: var(--dark);\n}\n\n.home-about__what-we-do-description {\n\tfont-family: \"Poppins\", sans-serif;\n\tmax-width: 550px;\n\ttext-align: end;\n\tfont-size: 20px;\n\tline-height: 24px;\n\tcolor: var(--dark);\n}\n\n.home-about__offers-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tpadding-bottom: 40px;\n}\n\n.home-about__offer-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tmax-width: 440px;\n\twidth: 100%;\n\talign-items: center;\n\tmin-height: 230px;\n}\n\n.home-about__offer-block.center {\n\tmargin: 0 auto;\n}\n\n.home-about__offer-block.end {\n\tmargin-left: auto;\n}\n\n.home-about__offer-text-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.home-about__offer-block-title {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 32px;\n\tline-height: 32px;\n\tfont-weight: 400;\n\tcolor: var(--dark);\n\tmax-width: 374px;\n\ttext-align: center;\n}\n\n.home-about__offer-block-description {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 20px;\n\tline-height: 24px;\n\tcolor: var(--dark);\n\ttext-align: center;\n\tfont-weight: 300;\n}\n\n.home-usage-block {\n\tdisplay: grid;\n\tgap: 40px;\n\twidth: 100%;\n\tgrid-template-columns: 520px 1fr;\n\tmax-width: 1340px;\n}\n\n.home-usage__information-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tgap: 80px;\n\twidth: 100%;\n}\n\n.home-usage__description-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n\tfont-family: \"Poppins\", sans-serif;\n}\n\n.home-usage__title {\n\tfont-size: 48px;\n\tfont-weight: 400;\n\tline-height: 48px;\n\tcolor: var(--dark);\n\ttext-transform: uppercase;\n\tfont-family: \"Poppins\", sans-serif;\n}\n\n.home-usage__subtitle {\n\tfont-size: 32px;\n\tline-height: 32px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n}\n\n.home-usage__description {\n\tfont-size: 20px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 300;\n}\n\n.home-usage__join-button {\n\theight: 60px;\n\tpadding: 0 20px;\n\twidth: fit-content;\n\tborder-radius: 12px;\n\tbackground-color: var(--button);\n\tcolor: var(--background);\n\tmargin-top: 40px;\n\tfont-size: 20px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 500;\n\ttext-transform: uppercase;\n\ttransition: 0.3s;\n}\n\n.home-usage__join-button:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.home-usage__videos-block {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n}\n\n.home-usage__video-wrapper {\n\twidth: 150px;\n\theight: 100%;\n\tposition: relative;\n\ttransition: 0.5s;\n\tborder-radius: 30px;\n\tborder: 2px solid var(--background);\n\tz-index: 1;\n}\n\n.home-usage__video-wrapper.current {\n\twidth: calc(100% - 120px);\n\ttransition: 0.5s;\n\tz-index: 2;\n}\n\n.home-usage__video-wrapper.current.first {\n\tmargin-right: -30px;\n}\n\n.home-usage__video-wrapper.current.second {\n\tmargin-left: -30px;\n}\n\n.home-usage__video {\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 30px;\n\ttransition: 0.5s;\n}\n\n.home-usage__video-dark-block {\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tbackground-color: rgba(0, 0, 0, 0.6);\n\tborder-radius: 30px;\n\tleft: 0;\n\ttop: 0;\n\tcursor: pointer;\n\ttransition: 0.5s;\n}\n\n.home-story-block {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 530px;\n\tgap: 40px;\n\twidth: 100%;\n\tmax-width: 1340px;\n\tpadding-bottom: 80px;\n}\n\n.home-story__image-block {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\tpadding-right: 100px;\n\tposition: relative;\n}\n\n.home-story__image-block img {\n\twidth: 100%;\n}\n\n.home-story__text-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 40px;\n\talign-items: end;\n}\n\n.home-story__points {\n\tposition: absolute;\n\tbottom: 20px;\n\tright: 0;\n\tmax-width: 280px;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.home-story__point {\n\tbackground-color: var(--button);\n\theight: 65px;\n\tpadding: 0 20px;\n\tborder-radius: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: var(--background);\n\tfont-size: 24px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\ttext-align: center;\n\ttext-transform: uppercase;\n}\n\n.home-story__title {\n\tfont-size: 48px;\n\tline-height: 48px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\ttext-transform: uppercase;\n\tcolor: var(--dark);\n\ttext-align: end;\n}\n\n.home-story__text {\n\tfont-size: 20px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 300;\n\ttext-align: end;\n\tcolor: var(--dark);\n}\n\n.home-story__conclusion {\n\tfont-size: 24px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\ttext-align: end;\n\tcolor: var(--dark);\n\ttext-transform: uppercase;\n}\n\n.home-usage__description-block-mobile {\n\tdisplay: none;\n}\n\n.home-story__title-mobile {\n\tdisplay: none;\n}\n\n.home-usage__mobile-video-dots {\n\tdisplay: none;\n}\n\n@media (max-width: 1150px) {\n\t.home-usage-block {\n\t\tdisplay: grid;\n\t\tgap: 40px;\n\t\twidth: 100%;\n\t\tgrid-template-columns: 420px 1fr;\n\t\tmax-width: 1340px;\n\t\tmargin-top: -40px;\n\t}\n\n\t.home-about__offer-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 16px;\n\t\tmax-width: 440px;\n\t\twidth: 100%;\n\t\talign-items: center;\n\t\tmin-height: fit-content;\n\t}\n\n\t.home-usage__information-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tgap: 60px;\n\t\twidth: 100%;\n\t}\n\n\t.home-usage__title {\n\t\tfont-size: 42px;\n\t\tfont-weight: 400;\n\t\tline-height: 42px;\n\t\tcolor: var(--dark);\n\t\ttext-transform: uppercase;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t}\n\n\t.home-usage__subtitle {\n\t\tfont-size: 26px;\n\t\tline-height: 26px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t}\n\n\t.home-usage__description {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 300;\n\t}\n\n\t.home-usage__join-button {\n\t\theight: 50px;\n\t\tpadding: 0 20px;\n\t\twidth: fit-content;\n\t\tborder-radius: 12px;\n\t\tbackground-color: var(--button);\n\t\tcolor: var(--background);\n\t\tmargin-top: 30px;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 500;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.home-story__text-block {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 32px;\n\t\talign-items: end;\n\t}\n\n\t.home-story__points {\n\t\tposition: absolute;\n\t\tbottom: 20px;\n\t\tright: 0;\n\t\tmax-width: 250px;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 16px;\n\t}\n\n\t.home-story__point {\n\t\tbackground-color: var(--button);\n\t\theight: 50px;\n\t\tpadding: 0 20px;\n\t\tborder-radius: 10px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: var(--background);\n\t\tfont-size: 18px;\n\t\tline-height: 22px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.home-story__title {\n\t\tfont-size: 42px;\n\t\tline-height: 42px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--dark);\n\t\ttext-align: end;\n\t}\n\n\t.home-story__text {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 300;\n\t\ttext-align: end;\n\t\tcolor: var(--dark);\n\t}\n\n\t.home-story__conclusion {\n\t\tfont-size: 20px;\n\t\tline-height: 24px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-align: end;\n\t\tcolor: var(--dark);\n\t\ttext-transform: uppercase;\n\t}\n\n\t.home-story-block {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 500px;\n\t\tgap: 40px;\n\t\twidth: 100%;\n\t\tmax-width: 1340px;\n\t\tpadding-bottom: 80px;\n\t}\n\n\t.home-introduction__title {\n\t\tfont-size: 80px;\n\t\ttext-transform: uppercase;\n\t\tline-height: 96px;\n\t\tfont-family: \"Pridi\", serif !important;\n\t\tfont-weight: 500;\n\t\tanimation: title 2.5s;\n\t}\n\n\t.home-introduction__subtitle {\n\t\tfont-size: 52px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tline-height: 60px;\n\t\tletter-spacing: 0.18em;\n\t\tfont-weight: 300;\n\t\ttext-align: end;\n\t\tanimation: subtitle 2.5s;\n\t}\n\n\t.home-introduction-block {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tgap: 80px;\n\t\tpadding-top: 100px;\n\t\tpadding-bottom: 0px;\n\t\tposition: relative;\n\t\tmax-width: 1340px;\n\t}\n\n\t.home-about__what-we-do {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 500;\n\t\tfont-size: 42px;\n\t\tline-height: 42px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--dark);\n\t}\n\n\t.home-about__what-we-do-description {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tmax-width: 450px;\n\t\ttext-align: end;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tcolor: var(--dark);\n\t}\n\n\t.home-about-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tgap: 12px;\n\t\tposition: relative;\n\t\tmax-width: 1340px;\n\t\tpadding-bottom: 40px;\n\t}\n\n\t.home-about__offer-block-title {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-size: 30px;\n\t\tline-height: 30px;\n\t\tfont-weight: 400;\n\t\tcolor: var(--dark);\n\t\tmax-width: 374px;\n\t\ttext-align: center;\n\t}\n\n\t.home-about__offer-block-description {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-size: 19px;\n\t\tline-height: 20px;\n\t\tcolor: var(--dark);\n\t\ttext-align: center;\n\t\tfont-weight: 300;\n\t}\n\n\t.home-about__offer-text-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 16px;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.home-introduction-block {\n\t\tmin-height: calc(100vh - 70px);\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tgap: 60px;\n\t\tpadding-top: 80px;\n\t\tpadding-bottom: 60px;\n\t\tposition: relative;\n\t\tmax-width: 1340px;\n\t}\n\n\t.home-introduction__title {\n\t\tfont-size: 36px;\n\t\ttext-transform: uppercase;\n\t\tline-height: 42px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\tanimation: title 2.5s;\n\t}\n\n\t.home-introduction__subtitle {\n\t\tfont-size: 24px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tline-height: 64px;\n\t\tletter-spacing: 0.1em;\n\t\tfont-weight: 300;\n\t\ttext-align: end;\n\t\tanimation: subtitle 2.5s;\n\t}\n\n\t.home-introduction__join-us-button {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 22px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tline-height: 26px;\n\t\tcolor: var(--dark);\n\t\twidth: fit-content;\n\t\tpadding: 0 16px;\n\t\tbackground-color: var(--button);\n\t\tcolor: var(--background);\n\t\theight: 44px;\n\t\tborder-radius: 12px;\n\t}\n\n\t.home-introduction__directions-block {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tgap: 16px;\n\t\tjustify-content: center;\n\t\tposition: absolute;\n\t\tbottom: 20px;\n\t\tright: 50%;\n\t\ttransform: translateX(50%);\n\t}\n\n\t.home-introduction__direction-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 32px;\n\t\tborder-radius: 20px;\n\t\tborder: 1px solid var(--dark);\n\t\tpadding: 0 8px;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 14px;\n\t\twhite-space: nowrap;\n\t}\n\n\t.home-content-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\talign-items: center;\n\t\tgap: 80px;\n\t}\n\n\t.home-introduction__join-us-block img {\n\t\tmax-height: 26px;\n\t}\n\n\t.home-about__main-intro {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 24px;\n\t\talign-items: start;\n\t}\n\n\t.home-about__what-we-do {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--dark);\n\t}\n\n\t.home-about__what-we-do-description {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tmax-width: 550px;\n\t\ttext-align: start;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tcolor: var(--dark);\n\t}\n\n\t.home-about-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tgap: 30px;\n\t\tposition: relative;\n\t\tmax-width: 1340px;\n\t\tpadding-bottom: 0;\n\t}\n\n\t.home-about__offers-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tpadding-bottom: 40px;\n\t\tgap: 16px;\n\t}\n\n\t.home-about__offer-text-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 12px;\n\t}\n\n\t.home-about__offer-block-title {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-size: 20px;\n\t\tline-height: 22px;\n\t\tfont-weight: 400;\n\t\tcolor: var(--dark);\n\t\tmax-width: 374px;\n\t\ttext-align: center;\n\t}\n\n\t.home-about__offer-block-description {\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tcolor: var(--dark);\n\t\ttext-align: center;\n\t\tfont-weight: 300;\n\t}\n\n\t.home-usage-block {\n\t\tdisplay: grid;\n\t\tgap: 24px;\n\t\twidth: 100%;\n\t\tgrid-template-columns: 1fr;\n\t\tmax-width: 1340px;\n\t}\n\n\t.home-usage__description-block {\n\t\tdisplay: none;\n\t\tflex-direction: column;\n\t\tgap: 12px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t}\n\n\t.home-usage__title {\n\t\tfont-size: 32px;\n\t\tfont-weight: 400;\n\t\tline-height: 32px;\n\t\tcolor: var(--dark);\n\t\ttext-transform: uppercase;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t}\n\n\t.home-usage__description-block-mobile {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 12px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t}\n\n\t.home-usage__video-wrapper {\n\t\twidth: 150px;\n\t\theight: 100%;\n\t\tposition: relative;\n\t\ttransition: 0.5s;\n\t\tborder-radius: 16px;\n\t\tborder: 2px solid var(--background);\n\t\tz-index: 1;\n\t\tdisplay: none;\n\t}\n\n\t.home-usage__video-wrapper.current {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tmin-height: 240px;\n\t\ttransition: 0.5s;\n\t\tz-index: 2;\n\t}\n\n\t.home-usage__video-wrapper.current.first {\n\t\tmargin-right: 0px;\n\t}\n\n\t.home-usage__video-wrapper.current.second {\n\t\tmargin-left: 0px;\n\t}\n\n\t.home-usage__video {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder-radius: 16px;\n\t\ttransition: 0.5s;\n\t}\n\n\t.home-usage__subtitle {\n\t\tfont-size: 20px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t}\n\n\t.home-usage__description {\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 300;\n\t}\n\n\t.home-usage__join-button {\n\t\theight: 44px;\n\t\tpadding: 0 16px;\n\t\twidth: fit-content;\n\t\tborder-radius: 12px;\n\t\tbackground-color: var(--button);\n\t\tcolor: var(--background);\n\t\tmargin-top: 10px;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t}\n\n\t.home-story-block {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 30px;\n\t\twidth: 100%;\n\t\tmax-width: 1340px;\n\t\tpadding-bottom: 80px;\n\t}\n\n\t.home-story__image-block {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tpadding-right: 0;\n\t\tposition: relative;\n\t}\n\n\t.home-story__points {\n\t\tposition: absolute;\n\t\tbottom: 20px;\n\t\tright: 0;\n\t\tmax-width: 280px;\n\t\twidth: 100%;\n\t\tdisplay: none;\n\t\tflex-direction: column;\n\t\tgap: 16px;\n\t}\n\n\t.home-story__title {\n\t\tfont-size: 48px;\n\t\tline-height: 48px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--dark);\n\t\ttext-align: end;\n\t\tdisplay: none;\n\t}\n\n\t.home-story__title-mobile {\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--dark);\n\t\ttext-align: start;\n\t\tdisplay: block;\n\t}\n\n\t.home-story__text-block {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 24px;\n\t\talign-items: start;\n\t}\n\n\t.home-story__text {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 300;\n\t\ttext-align: start;\n\t\tcolor: var(--dark);\n\t}\n\n\t.home-story__conclusion {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tfont-weight: 400;\n\t\ttext-align: start;\n\t\tcolor: var(--dark);\n\t\ttext-transform: uppercase;\n\t}\n\n\t.home-usage__videos-block {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 12px;\n\t\talign-items: center;\n\t}\n\n\t.home-usage__mobile-video-dots {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t}\n\n\t.home-usage__mobile-video-dot {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: var(--gray);\n\t}\n\n\t.home-usage__mobile-video-dot.current {\n\t\tbackground-color: var(--button);\n\t}\n}\n\n.banner {\n\tmin-height: 500px;\n\tbackground: linear-gradient(360deg, #e9eff2 0%, #f6fbff 100%);\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.section-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-wrap: wrap;\n}\n\n.banner-headline {\n\tfont-style: normal;\n\tfont-weight: 900;\n\tfont-size: 64px;\n\tline-height: 120%;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tcolor: #203f70;\n}\n\n.banner-title {\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 64px;\n\tline-height: 100%;\n\tcolor: #203f70;\n}\n\n.about-us {\n\tposition: relative;\n\tz-index: 1;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.about-headline {\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 52px;\n\tline-height: 100%;\n\tcolor: #203f70;\n}\n\n.about-title {\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 24px;\n\tline-height: 36px;\n\ttext-align: center;\n\tcolor: #000000;\n}\n\n.max-width-785 {\n\tmax-width: 785px;\n}\n\n.about-description {\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\ttext-align: center;\n\tcolor: #707070;\n}\n\n.about-row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.about-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: center;\n\tmax-width: 380px;\n}\n\n.about-wrapper {\n\tmax-width: 360px;\n}\n\n.about-wrapper img {\n\twidth: 42px;\n\theight: 42px;\n}\n\n.about-bllock-title {\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 24px;\n\tline-height: 36px;\n\tcolor: #000000;\n\tmargin-top: 10px !important;\n}\n\n.about-bllock-desc {\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #707070;\n}\n\n.about-img-block img {\n\tmax-width: 340px;\n\tmargin-right: 15px;\n}\n\n@media (max-width: 1400px) {\n\t.about-block {\n\t\tmax-width: 100%;\n\t\tflex-basis: 100%;\n\t\tmargin: 0 !important;\n\t\talign-items: center;\n\t}\n\n\t.about-img-block {\n\t\tmargin-top: 20px;\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n.product-promotion {\n\tpadding: 100px 0;\n\tpadding-top: 0px;\n\tbackground: #cbdefd;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.promotion-wrapper {\n\twidth: 50%;\n\tflex-basis: 50%;\n\tmax-width: 540px;\n}\n\n.promotion-headline {\n\tpadding-bottom: 100px;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 52px;\n\tline-height: 100%;\n\tcolor: #203f70;\n}\n\n.promotion-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n}\n\n.promotion-block img {\n\twidth: 100%;\n\tmax-width: 580px;\n}\n\n.promotion-block-title {\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 24px;\n\tline-height: 36px;\n\tcolor: #000000;\n}\n\n.promotion-block-subtitle {\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #000000;\n}\n\n.promotion-bllock-desc {\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #000000;\n}\n\n@media (max-width: 992px) {\n\t.product-promotion-grid {\n\t\tflex-direction: column !important;\n\t\talign-items: center !important;\n\t}\n\n\t.promotion-block {\n\t\tmargin: 15px 0px !important;\n\t}\n\n\t.product-promotion {\n\t\tpadding: 50px 0;\n\t}\n\n\t.about-row {\n\t\tflex-wrap: wrap;\n\t}\n\n\t.about-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t.about-bllock-title {\n\t\ttext-align: center;\n\t}\n\n\t.about-bllock-desc {\n\t\ttext-align: center;\n\t}\n\n\t.promotion-wrapper {\n\t\twidth: 70%;\n\t}\n\n\t.promotion-btn {\n\t\tmargin-top: 10px !important;\n\t\talign-items: center;\n\t}\n\n\t.about-wrapper {\n\t\tmax-width: 450px;\n\t}\n}\n\n.quote-area {\n\tpadding: 70px 0;\n\tbackground: linear-gradient(\n\t\t360deg,\n\t\t#e9eff2 7.29%,\n\t\t#e9eff2 19.79%,\n\t\t#f6fbff 100%\n\t);\n}\n\n.quote-area-title {\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 52px;\n\tline-height: 100%;\n\tcolor: #203f70;\n}\n\n@media (max-width: 500px) {\n\t.banner-headline {\n\t\tfont-size: 48px;\n\t}\n\n\t.banner-title {\n\t\tfont-size: 48px;\n\t}\n\n\t.about-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t.about-bllock-title {\n\t\ttext-align: center;\n\t}\n\n\t.about-bllock-desc {\n\t\ttext-align: center;\n\t}\n\n\t.about-img-block img {\n\t\tmargin-right: 0px;\n\t}\n\n\t.promotion-wrapper {\n\t\twidth: 80%;\n\t}\n\n\t.promotion-btn {\n\t\tmargin-top: 10px !important;\n\t}\n\n\t.about-headline {\n\t\ttext-align: center;\n\t}\n}\n\n.our-story {\n\tposition: relative;\n\tz-index: 1;\n\tbackground-color: #203f70;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.story-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: center;\n\tmax-width: 600px;\n}\n\n.story-row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.story-image-block img {\n\tmax-width: 160px;\n\tmargin-right: 60px;\n}\n\n.story-headline {\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 52px;\n\tline-height: 100%;\n\tcolor: #ffffff;\n}\n\n.story-description {\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 20px;\n\tline-height: 24px;\n\ttext-align: left;\n\tcolor: #ffffff;\n}\n\n.story-description-emph {\n\tfont-style: normal;\n\tfont-weight: 300;\n\tfont-size: 28px;\n\tline-height: 28px;\n\ttext-align: center;\n\tcolor: #ffffff;\n}\n\n.story-title {\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 24px;\n\tline-height: 36px;\n\ttext-align: left;\n\tcolor: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
